import { useEffect, useRef, useState } from "react";
import { useCallingContext } from "../../../context/CallingContext";
import { useInfoUser } from "../../../store/UserStore";
import "./GroupCall.scss";
import { ImPhoneHangUp } from "react-icons/im";
import { LuCamera, LuCameraOff } from "react-icons/lu";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa6";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { MediaSetting } from "../../../components/modal/calling/camera/MediaSetting";
import { IoMdSettings, IoMdWarning } from "react-icons/io";
import { CustomAvatar } from "../../../components/avatar/CustomAvatar";
import callingMusic from "../../../assets/waiting-music.mp3";
import { CgScreen } from "react-icons/cg";
import { GoPersonAdd } from "react-icons/go";
import { PickMemberModal } from "../../../components/modal/calling/PickMemberModal";
import { DirectoryProvider } from "../../../components/select/directory/DirectoryContext";
import { MdOutlineStopScreenShare } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";
import { Col, Row } from "antd";

const Speaker = ({ member, mediaStream }) => {
  const { user } = useInfoUser();
  const streamRef = useRef(null);
  const { focusId } = useCallingContext();

  const playMediaStream = async () => {
    if (streamRef.current && mediaStream?.screenStream) {
      streamRef.current.srcObject = mediaStream?.screenStream;
      streamRef.current
        .play()
        .catch((e) => console.warn("Lỗi auto play video:", e));
    }
  };

  useEffect(() => {
    playMediaStream();
  }, [mediaStream?.screenStream]);

  return (
    <div
      className={`bg-[#222] flex flex-col overflow-hidden items-center justify-end h-full`}
    >
      <div className="flex flex-col justify-center items-center gap-[10px] flex-1">
        <video ref={streamRef} autoPlay playsInline muted />
      </div>
      <div className="flex justify-between w-[100%]">
        <div className="username">{member?.memberName} is sharing screen</div>
      </div>
    </div>
  );
};

const Me = ({ member }) => {
  const { user } = useInfoUser();
  const { orgList } = useAuthLayoutContext();

  const { localStream, focusId } = useCallingContext();
  const streamRef = useRef(null);
  const person = orgList?.find((org) => org.userCode === member?.memberId);

  const playMediaStream = async () => {
    if (streamRef.current && localStream?.videoStream) {
      streamRef.current.srcObject = localStream?.videoStream;
      streamRef.current
        .play()
        .catch((e) => console.warn("Lỗi auto play video:", e));
    }
  };

  useEffect(() => {
    playMediaStream();
  }, [localStream?.videoStream, localStream?.video, localStream?.audio]);

  return (
    <div
      className={`bg-[#222] flex flex-col overflow-hidden items-center justify-end h-full`}
    >
      <div className="flex flex-col justify-center items-center gap-[10px] flex-1">
        {/*{generate(localStream, person)}*/}
        <MemberMedia mediaStream={localStream} person={person} />
        <MemberStatus member={member} />
      </div>
      <div className="flex justify-between w-[100%]">
        <div className="username">{member?.memberName}</div>
        {member?.status && user?.userId !== member?.memberId ? (
          <div className="action">
            {!localStream?.isVideoLost ? (
              <button>
                <LuCamera size={16} />
              </button>
            ) : (
              <button>
                <LuCameraOff size={16} />
              </button>
            )}
            {localStream?.audio ? (
              <button>
                <FaMicrophone size={16} />
              </button>
            ) : (
              <button>
                <FaMicrophoneSlash size={16} />
              </button>
            )}
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

const MemberStatus = ({ member }) => {
  const { user } = useInfoUser();

  if (member?.status && user?.userId === member?.memberId)
    return <div className="h-[34.5px]" />;

  if (member?.status === "RINGING")
    return <div className="h-[34.5px]">Ringing ...</div>;

  if (member?.status === "REJECTED")
    return <div className="h-[34.5px]">Busy ...</div>;

  return <div className="h-[34.5px]" />;
};

const MemberMedia = ({ mediaStream, person }) => {
  const { user } = useInfoUser();

  const streamRef = useRef(null);
  const playMediaStream = async () => {
    if (streamRef.current && mediaStream?.videoStream) {
      streamRef.current.srcObject = mediaStream?.videoStream;
      streamRef.current
        .play()
        .catch((e) => console.warn("Lỗi auto play video:", e));
    }
  };

  useEffect(() => {
    playMediaStream();
  }, [mediaStream?.videoStream, mediaStream?.video, mediaStream?.audio]);

  if (!mediaStream?.audio && !mediaStream?.video)
    return (
      <div className="">
        <CustomAvatar
          person={person}
          userId={person?.userCode}
          pos={-1}
          styleCss={{}}
          isShowUserStatus={{ status: false, isAlwaysTrue: false }}
          size={80}
        />
      </div>
    );

  if (!mediaStream?.video)
    return (
      <>
        <CustomAvatar
          person={person}
          userId={person?.userCode}
          pos={-1}
          styleCss={{}}
          isShowUserStatus={{ status: false, isAlwaysTrue: false }}
          size={80}
        />
        <audio
          ref={streamRef}
          autoPlay
          playsInline
          muted={user?.userId === person?.userCode}
        />
      </>
    );

  return (
    <video
      className="h-full aspect-video"
      ref={streamRef}
      autoPlay
      playsInline
      muted={user?.userId === person?.userCode}
    />
  );
};

const ScreenSharing = () => {
  const { localStream } = useCallingContext();

  const streamRef = useRef(null);
  const playMediaStream = async () => {
    if (streamRef.current && localStream?.screenStream) {
      streamRef.current.srcObject = localStream?.screenStream;
      streamRef.current
        .play()
        .catch((e) => console.warn("Lỗi auto play video:", e));
    }
  };

  useEffect(() => {
    playMediaStream();
  }, [localStream?.screenStream]);

  return (
    <video
      className="h-full aspect-video"
      ref={streamRef}
      autoPlay
      playsInline
      muted
    />
  );
};

const MemberMedia2 = ({ mediaStream }) => {
  const streamRef = useRef(null);
  const playMediaStream = async () => {
    if (streamRef.current && mediaStream?.screenStream) {
      streamRef.current.srcObject = mediaStream?.screenStream;
      streamRef.current
        .play()
        .catch((e) => console.warn("Lỗi auto play video:", e));
    }
  };

  useEffect(() => {
    playMediaStream();
  }, [mediaStream?.screenStream]);

  return (
    <video
      className="h-full aspect-video"
      ref={streamRef}
      autoPlay
      playsInline
      muted
    />
  );
};

const Member = ({ member, mediaStream }) => {
  const { user } = useInfoUser();
  const { orgList } = useAuthLayoutContext();

  const { focusId } = useCallingContext();

  const person = orgList?.find((org) => org.userCode === member.memberId);

  return (
    <div
      className={`bg-[#222] flex flex-col overflow-hidden items-center justify-end h-full`}
    >
      <div className="flex flex-col justify-center items-center gap-[10px] flex-1">
        <MemberMedia mediaStream={mediaStream} person={person} />
        <MemberStatus member={member} />
      </div>
      <div className="flex justify-between w-[100%]">
        <div className="username">{member?.memberName}</div>
        {member?.status && user?.userId !== member?.memberId ? (
          <div className="action">
            {mediaStream?.video ? (
              <button>
                <LuCamera size={16} />
              </button>
            ) : (
              <button>
                <LuCameraOff size={16} />
              </button>
            )}
            {mediaStream?.audio ? (
              <button>
                <FaMicrophone size={16} />
              </button>
            ) : (
              <button>
                <FaMicrophoneSlash size={16} />
              </button>
            )}
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

const FocusMember = () => {
  const { user } = useInfoUser();
  const { orgList } = useAuthLayoutContext();

  const { focusId, localStream, remoteStreams, room, cancelFocusMember } =
    useCallingContext();

  const person = orgList?.find((org) => org.userCode === focusId);

  const mediaStream = remoteStreams?.find((rs) => rs?.targetId === focusId);

  const member = room?.members?.find(
    (mb) =>
      (focusId?.includes("screen") &&
        mb?.memberId + ":screen" === focusId &&
        mb?.isScreen) ||
      (mb?.memberId === focusId && !mb?.isScreen),
  );

  return (
    <div
      className="bg-[#222] flex-1 flex flex-col justify-center items-center relative"
      onDoubleClick={cancelFocusMember}
    >
      <button
        className="absolute top-[10px] right-[10px]"
        onClick={cancelFocusMember}
      >
        <AiOutlineClose size={20} />
      </button>
      <div className="flex flex-col justify-center items-center gap-[10px] h-[96%]">
        {focusId?.includes("screen") && focusId?.includes(user?.userId) && (
          <ScreenSharing />
        )}
        {focusId?.includes("screen") && !focusId?.includes(user?.userId) && (
          <MemberMedia2 mediaStream={mediaStream} />
        )}

        {focusId === user?.userId && <MemberMedia mediaStream={localStream} />}

        {!focusId?.includes("screen") && focusId !== user?.userId && (
          <>
            <MemberMedia mediaStream={mediaStream} person={person} />
            <MemberStatus member={member} />
          </>
        )}
      </div>
      <div className="flex justify-between gap-[100px] w-[100%]">
        <div className="username">
          <div>{member?.memberName}</div>
          <div>{focusId?.includes("screen") && "is sharing screen"}</div>
        </div>
        {member?.status && user?.userId !== member?.memberId ? (
          <div className="action">
            {mediaStream?.video ? (
              <button>
                <LuCamera size={16} />
              </button>
            ) : (
              <button>
                <LuCameraOff size={16} />
              </button>
            )}
            {mediaStream?.audio ? (
              <button>
                <FaMicrophone size={16} />
              </button>
            ) : (
              <button>
                <FaMicrophoneSlash size={16} />
              </button>
            )}
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

const MemberGrid = () => {
  const { user } = useInfoUser();

  const { room, localStream, remoteStreams, focusId, onFocusMember } =
    useCallingContext();

  if (focusId) return;

  return (
    <Row className="h-full">
      {room?.members?.map((member) => {
        if (member?.isScreen) {
          return (
            <Col
              span={room?.members?.length < 5 ? 12 : 8}
              className={`${room?.members?.length === 2 ? "h-[70%]" : "h-[50%]"} p-[10px]`}
              key={member?.memberId}
              onDoubleClick={() => onFocusMember(member?.memberId + ":screen")}
            >
              {room?.members?.length < 3 && <div className="h-[25%]" />}

              <Speaker
                member={member}
                mediaStream={
                  member?.memberId === user?.userId
                    ? localStream
                    : remoteStreams?.find(
                        (r) => r?.targetId === member?.memberId + ":screen",
                      )
                }
              />
            </Col>
          );
        }

        if (user?.userId === member?.memberId)
          return (
            <Col
              span={room?.members?.length < 5 ? 12 : 8}
              className={`${room?.members?.length === 2 ? "h-[70%]" : "h-[50%]"} p-[10px]`}
              key={member?.memberId}
              onDoubleClick={() => onFocusMember(member?.memberId)}
            >
              {room?.members?.length < 3 && <div className="h-[25%]" />}
              <Me member={member} />
            </Col>
          );

        return (
          <Col
            span={room?.members?.length < 5 ? 12 : 8}
            className={`${room?.members?.length === 2 ? "h-[70%]" : "h-[50%]"} p-[10px]`}
            key={member?.memberId}
            onDoubleClick={() => onFocusMember(member?.memberId)}
          >
            {room?.members?.length < 3 && <div className="h-[25%]" />}

            <Member
              member={member}
              mediaStream={remoteStreams?.find(
                (r) => r?.targetId === member?.memberId,
              )}
            />
          </Col>
        );
      })}
    </Row>
  );
};

const FocusGrid = () => {
  const { focusId } = useCallingContext();

  if (!focusId) return null;

  return (
    <div className="flex flex-row gap-[20px] justify-between h-full">
      <FocusMember />
      <MemberList />
    </div>
  );
};

const MemberList = () => {
  const { user } = useInfoUser();

  const { focusId, remoteStreams, room, localStream, onFocusMember } =
    useCallingContext();

  if (!focusId) return;

  return (
    <div className="flex flex-col w-[20%] overflow-y-auto gap-[10px]">
      {room?.members?.map((member) => {
        if (
          (member?.memberId === focusId && !member?.isScreen) ||
          (member?.memberId + ":screen" === focusId && member?.isScreen)
        )
          return null;

        if (member?.isScreen) {
          return (
            <div
              onDoubleClick={() => onFocusMember(member?.memberId + ":screen")}
              className="h-[50%]"
            >
              <Speaker
                member={member}
                mediaStream={
                  member?.memberId === user?.userId
                    ? localStream
                    : remoteStreams?.find(
                        (r) => r?.targetId === member?.memberId + ":screen",
                      )
                }
              />
            </div>
          );
        }

        if (user?.userId === member?.memberId)
          return (
            <div
              onDoubleClick={() => onFocusMember(member?.memberId)}
              className="h-[50%]"
            >
              <Me member={member} />
            </div>
          );

        return (
          <div
            onDoubleClick={() => onFocusMember(member?.memberId)}
            className="h-[50%]"
          >
            <Member
              member={member}
              mediaStream={remoteStreams?.find(
                (r) => r?.targetId === member?.memberId,
              )}
            />
          </div>
        );
      })}
    </div>
  );
};

const InCalling = () => {
  const {
    leaveCall,
    isClosed,
    room,
    localStream,
    selectedAudioId,
    selectedVideoId,
    turnCamera,
    turnMic,
    timeoutRef,
    onSharingScreen,
    closeSharingScreen,
  } = useCallingContext();

  const [isOpenMediaSetting, setIsOpenMediaSetting] = useState(false);
  const [isPickCallMember, setIsPickCallMember] = useState(false);

  useEffect(() => {
    if (isClosed) window.close();
  }, [isClosed]);

  return (
    <div className="call-page">
      <div className="call-window flex flex-col h-full">
        <div className="call-header">
          {!selectedAudioId && !selectedVideoId && (
            <div className="flex gap-[5px] items-center">
              <IoMdWarning size={16} color="yellow" />
              <div>Not found any camera!</div>
            </div>
          )}
        </div>

        <div className="flex-1 min-h-0 overflow-auto">
          <MemberGrid />
          <FocusGrid />
        </div>

        <div className="call-footer">
          <div className="left-actions">
            {localStream?.screen ? (
              <button className="icon-btn" onClick={closeSharingScreen}>
                <MdOutlineStopScreenShare size={18} />
              </button>
            ) : (
              <button className="icon-btn" onClick={onSharingScreen}>
                <CgScreen size={18} />
              </button>
            )}
            <button
              className="icon-btn"
              onClick={() => setIsPickCallMember(true)}
            >
              <GoPersonAdd size={18} />
            </button>
          </div>

          <div className="main-actions">
            <button className="control-btn" onClick={turnCamera}>
              {localStream?.video ? (
                <LuCamera size={18} />
              ) : (
                <LuCameraOff size={18} />
              )}
            </button>
            <button className="control-btn end-call" onClick={leaveCall}>
              <ImPhoneHangUp />
            </button>
            <button className="control-btn" onClick={turnMic}>
              {localStream?.audio ? (
                <FaMicrophone size={18} />
              ) : (
                <FaMicrophoneSlash size={18} />
              )}
            </button>
          </div>

          <div className="right-actions">
            <button
              className="icon-btn"
              onClick={() => setIsOpenMediaSetting(true)}
            >
              <IoMdSettings size={18} />
            </button>
          </div>
        </div>
      </div>
      {isOpenMediaSetting && (
        <MediaSetting
          open={isOpenMediaSetting}
          onClose={() => setIsOpenMediaSetting(false)}
        />
      )}
      {timeoutRef?.current && (
        <audio src={callingMusic} preload="auto" autoPlay loop />
      )}

      {isPickCallMember && (
        <DirectoryProvider>
          <PickMemberModal
            selectedConversation={{ conversationId: room?.conversationId }}
            isPickCallMember={isPickCallMember}
            setIsPickCallMember={setIsPickCallMember}
            memberIds={room?.members?.map((member) => member?.memberId)}
            roomId={room?.roomId}
          />
        </DirectoryProvider>
      )}
    </div>
  );
};

export { InCalling };
